import "./App.css";
import AppRoutes from "./router.jsx";
import './index.css';

function App() {
  return <AppRoutes />;
}

export default App;

